import styled from 'styled-components';
import Header from './Header';
import { StartInspectionButton } from '../components/StartInspectionButton';
import { MobileVehicleCard } from './MobileVehicleCard';
import { CircularProgress } from '@material-ui/core';
import { useCallback, useEffect } from 'react';
import { CreateVehicleDialog } from '../../../../components/ListVehicles/components/CreateVehicleDialog';
import { UploadQuestionsDialog } from '../../../ListerVehicleUploadV2/QuestionsDialog';
import { LoadingDialog } from 'components/LoadingDialog';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import { DesktopVehicleCard } from './DesktopVehicleCard';
import { useVehicleListContext } from '../context';
import { adminVehicleHistoryApiSlice, useSyncBlueDriverVehiclesMutation } from 'services/api/admin-vehicle-history';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 50px;
`;

const LoaderWrapper = styled.div`
    width: 100%:
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const VehiclesListComponent = () => {
  const { vehicles, vehiclesCount, isFetching, loadMore } = useVehicleListContext();

  const handleScroll = useCallback(() => {
    if (isFetching || vehicles.length >= vehiclesCount) return;
    const el = document.getElementById('load-trigger');

    if (!el) return;

    const bounding = el.getBoundingClientRect();
    const isInViewPort = bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    if (isInViewPort) {
      if (vehicles.length < vehiclesCount) {
        loadMore();
      }
    }
  }, [loadMore, isFetching, vehicles.length, vehiclesCount]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, false);
    return () => window.removeEventListener('scroll', handleScroll, false);
  }, [handleScroll]);

  const { isMobile } = useDeviceInfo();

  const [, { isLoading: listerSyncing }] = useSyncBlueDriverVehiclesMutation({
    fixedCacheKey: 'bluerdriver-sync'
  });

  const CardComponent = isMobile ? MobileVehicleCard : DesktopVehicleCard;

  return (
    <div>
      <LoadingDialog />
      <UploadQuestionsDialog />
      <Header />
      <div className="pageWrapper" style={{ paddingTop: '80px' }}>
        <ContentWrapper>
          {listerSyncing && (
            <ProgressWrapper>
              <CircularProgress />
            </ProgressWrapper>
          )}
          {vehicles.map(v => (
            <CardComponent vehicle={v!} key={v!.id} />
          ))}
          <LoaderWrapper id="load-trigger">{isFetching ? <CircularProgress /> : null}</LoaderWrapper>
        </ContentWrapper>
        <CreateVehicleDialog />
        <StartInspectionButton />
      </div>
    </div>
  );
};
